module.exports = __webpack_public_path__ + "~@/assets/img/nanoLaw.ed4d7e33.png";